
import {of as observableOf,  Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IPrepareDatabaseContactsRequest, IPrepareExcelContactsRequest } from '@routes/addressbook/models/addressbook-model';
import { IPrepareDatabaseContactListsRequest, IPrepareDatabaseInvitationsRequest, IPrepareExcelInvitationsRequest } from '@routes/events/models/event-model';
import { IPrepareImportUsersRequest } from '@routes/usersteams/models/user-model';
import { IImportContacts, IImportContactLists, IImportInvitations, IImportUsers, IPrepareDatabaseContactsResponse, IPrepareDatabaseContactListsResponse,
    IPrepareDatabaseInvitationsResponse, IPrepareExcelContactsResponse, IPrepareExcelInvitationsResponse, IPrepareImportUsersResponse,
    IImportRecipients, IImportRecipientLists} from '@shared/services/api/legacy/imports-service/imports-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class ImportsService {

    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ImportsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/imports';

    public prepareExcelContacts(model: IPrepareExcelContactsRequest): Observable<SuccessResponse<IPrepareExcelContactsResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareExcelContactsResponse>>(ImportsService.URL + '/prepare/excel/contacts', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public prepareExcelInvitations(model: IPrepareExcelInvitationsRequest): Observable<SuccessResponse<IPrepareExcelInvitationsResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareExcelInvitationsResponse>>(ImportsService.URL + '/prepare/excel/invitations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public prepareDatabaseContacts(model: IPrepareDatabaseContactsRequest): Observable<SuccessResponse<IPrepareDatabaseContactsResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareDatabaseContactsResponse>>(ImportsService.URL + '/prepare/database/contacts', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public prepareDatabaseInvitations(model: IPrepareDatabaseInvitationsRequest): Observable<SuccessResponse<IPrepareDatabaseInvitationsResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareDatabaseInvitationsResponse>>(ImportsService.URL + '/prepare/database/invitations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public prepareDatabaseHubspotLists(model: IPrepareDatabaseContactListsRequest): Observable<SuccessResponse<IPrepareDatabaseContactListsResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareDatabaseContactListsResponse>>(ImportsService.URL + '/prepare/database/hubspotlists', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public prepareDatabaseMarketoLists(model: IPrepareDatabaseContactListsRequest): Observable<SuccessResponse<IPrepareDatabaseContactListsResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareDatabaseContactListsResponse>>(ImportsService.URL + '/prepare/database/marketolists', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importContacts(model: IImportContacts): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/contacts', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importInvitations(model: IImportInvitations): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/invitations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importRecipients(model: IImportRecipients): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/recipients', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importHubspotLists(model: IImportContactLists): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/hubspotlists/invitations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importHubspotRecipientLists(model: IImportRecipientLists): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/hubspotlists/recipients', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importMarketoLists(model: IImportContactLists): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/marketolists/invitations', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importMarketoRecipientLists(model: IImportRecipientLists): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/marketolists/recipients', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public importUsers(model: IImportUsers): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(ImportsService.URL + '/import/users', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public prepareImportUsers(model: IPrepareImportUsersRequest): Observable<SuccessResponse<IPrepareImportUsersResponse> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<IPrepareImportUsersResponse>>(ImportsService.URL + '/prepare/users', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
